import approvedPartnersDataReducer from './slices/approvedPartnersDataSlice';
import authReducer from './slices/authSlice';
import baVerificationStatsReducer from './slices/baVerificationStatsSlice';
import currentConfigDataReducer from './slices/currentConfigDataSlice';
import dashboardDataReducer from './slices/dashboardDataSlice';
import dispatchVolumeDataReducer from './slices/dispatchVolumeDataSlice';
import driverOverviewDataReducer from './slices/driverOverviewDataSlice';
import lifeTimeOnboardingDataReducer from './slices/lifeTimeOnboardingChartDataDataSlice';
import lookupMetricsReducer from './slices/lookupMetrics';
import priceManagementReducer from './slices/priceManagementSlice';
import routeAnalysisDataReducer from './slices/routeAnalysisDataSlice';
import signUpReducer from './slices/signUpSlice';
import verifyNINReducer from './slices/verifyNINSlice';

export const reducers = {
  auth: authReducer,
  signUpData: signUpReducer,
  approvedPartnersData: approvedPartnersDataReducer,
  priceManagementData: priceManagementReducer,
  lookupMetricsData: lookupMetricsReducer,
  dashboardData: dashboardDataReducer,
  lifeTimeOnboardingData: lifeTimeOnboardingDataReducer,
  driverOverviewData: driverOverviewDataReducer,
  routeAnalysisData: routeAnalysisDataReducer,
  dispatchVolumeData: dispatchVolumeDataReducer,
  currentConfigData: currentConfigDataReducer,
  baVerificationStatsData: baVerificationStatsReducer,
  verifyNIN: verifyNINReducer
};
